import StockApi from './StockApi'
import { store as secureLocalStorage } from './SecureLS'

function StockClient() {
  this.user = null
  this.claims = null
  this.authStateSubscribers = []
  this.store = secureLocalStorage

  setTimeout(() => {
    console.info(`Stock client initialized.`)
    this.dispatchStateChange('initialized')
  }, 1000)
}

StockClient.prototype.dispatchStateChange = function (state) {
  console.info(`STATE CHANGE FOR BYPASS LOGIN: ${state}`)
  for (const fn of this.authStateSubscribers) {
    fn(state)
  }
}

StockClient.prototype.onAuthStateChanged = function (watcher) {
  this.authStateSubscribers = [...this.authStateSubscribers, watcher]
}

StockClient.prototype.handleLogin = async function (barcode) {
  let options = {
    headers: {
      'user-barcode': barcode
    }
  }

  let { data } = await StockApi.post('/login', null, options)

  this.store.set(
    'shppr:stock:u',
    btoa(
      JSON.stringify({
        badge: data.badge,
        displayName: data.name
      })
    )
  )
  this.store.set('shppr:stock:c', btoa(JSON.stringify(data.claims)))
}

StockClient.prototype.dispatchLogIn = function () {
  this.dispatchStateChange('logged_in')
}

StockClient.prototype.handleLogout = function () {
  this.store.clear()
  this.dispatchStateChange('logged_out')
}

StockClient.prototype.getClaims = function (claim = null) {
  const claims = JSON.parse(atob(this.store.get('shppr:stock:c')))

  if (claim) {
    return claims.find((c) => c === claim)
  }

  return claims
}

StockClient.prototype.checkClaim = async function (claim) {
  if (!claim) return false

  const hasPermission = this.getClaims(claim) ? true : false
  return hasPermission
}

StockClient.prototype.getUser = function () {
  const user = this.store.get('shppr:stock:u')

  if (!user) return
  return JSON.parse(atob(user))
}

StockClient.prototype.lock = function () {
  this.dispatchStateChange('locked')
}

StockClient.prototype.unlock = async function () {
  this.dispatchStateChange('unlocked')
  return true
}

export default StockClient

export const checkLoginByPass = async function () {
  let { data } = await StockApi.get('/check-bypass')

  return data
}

export const setLoginMode = function (loginType = '') {
  if (!loginType) return
  secureLocalStorage.set('shppr:stock:tl', btoa(loginType))
}

export const checkLoginMode = function () {
  const loginMode = secureLocalStorage.get('shppr:stock:tl')

  if (!loginMode) {
    return ''
  }

  try {
    return atob(loginMode)
  } catch {
    return ''
  }
}
